__turbopack_context__.v({
  "account": "header-module__H0GFPa__account",
  "active": "header-module__H0GFPa__active",
  "blok-big-title": "header-module__H0GFPa__blok-big-title",
  "blok-subtitle": "header-module__H0GFPa__blok-subtitle",
  "blok-title": "header-module__H0GFPa__blok-title",
  "bottom": "header-module__H0GFPa__bottom",
  "burger": "header-module__H0GFPa__burger",
  "cart": "header-module__H0GFPa__cart",
  "close": "header-module__H0GFPa__close",
  "favourites": "header-module__H0GFPa__favourites",
  "header": "header-module__H0GFPa__header",
  "hidden": "header-module__H0GFPa__hidden",
  "icon": "header-module__H0GFPa__icon",
  "icons": "header-module__H0GFPa__icons",
  "intersector": "header-module__H0GFPa__intersector",
  "links": "header-module__H0GFPa__links",
  "logo": "header-module__H0GFPa__logo",
  "menu": "header-module__H0GFPa__menu",
  "mobile": "header-module__H0GFPa__mobile",
  "right": "header-module__H0GFPa__right",
  "scrolled": "header-module__H0GFPa__scrolled",
  "search": "header-module__H0GFPa__search",
  "top": "header-module__H0GFPa__top",
});
